import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
        backgroundColor: '#f5f5f5',
    }
});

const Imagem = (props) => {
    const classes = useStyles();
    const [conteudo] = useState({
        ...props.conteudo
    });

    return (
        <div>
            <CssBaseline />

            <Container className={classes.paper} component={Paper}>
                <img
                    alt=''
                    style={{
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginBottom: '20px',
                        width: conteudo.imagem.largura ? conteudo.imagem.largura : 300
                    }}
                    src={conteudo.imagem.imagemUrl}
                />
                <Typography
                    style={{
                        backgroundColor: 'white',
                        padding: '10px'

                    }}
                    variant="body2"
                    component="p"
                >
                    {conteudo.imagem.legenda}

                </Typography>
            </Container>

        </div>
    );
}

export default Imagem;